import { MapStore } from '@/store/mapStore'
import { UiStore } from '@/store/uiStore'
import { FacilityStore } from '@/store/facilityStore'
import { RightNavCtrlStore } from '@/store/rightNavCtrlStore'
import { MapFeatureStore } from '@/store/mapFeatureStore'
import { Measure } from '@/store/measure'
import { LayerList } from '@/store/layerList'
import { ShadeAnalysis } from '@/store/shadeAnalysis'
import { VolumeMeasure } from '@/store/measure/volume'

export const RootStore = {
  mapStore: new MapStore(),
  uiStore: new UiStore(),
  facilityStore: new FacilityStore(),
  rightNavCtrlStore: new RightNavCtrlStore(),
  mapFeatureStore: new MapFeatureStore(),
  measureStore: new Measure(),
  layerList: new LayerList(),
  shadeAnalysis: new ShadeAnalysis(),
  volumeStore: new VolumeMeasure(),
}
